/**
 * 页面要的角色(设计图 24:无权限页写明需要的角色与当前角色,不悄悄跳回首页)。
 * 员工(staff)那一层守卫里先判;这里管再细分的:评审员、线下赛裁判、一级合作机构(二级机构没有下级,层级上限 2 ——
 * 菜单本来就不出「下级机构」,直接敲地址进来也给无权限页,和别的无权限页一样)。
 */
export type RoleNeed = 'staff' | 'reviewer' | 'judge' | 'channel_l1';

/** 无权限页上「需要「…」角色」的说法 */
export const ROLE_NEED_LABELS: Record<RoleNeed, string> = {
  staff: '机构员工(管理员 / 教师 / 考务 / 监考)',
  reviewer: '评审员',
  judge: '线下赛裁判(扫主办方发的组二维码进组)',
  channel_l1: '一级合作机构(二级机构不能再开下级)',
};

/** 路由 meta 标了要的角色而当前账号没有 → 返回缺的那个;都满足 → null */
export function roleNeedOf(
  meta: Record<string | number | symbol, unknown>,
  who: { isReviewer: boolean; isJudge: boolean; isChannelL1: boolean },
): Exclude<RoleNeed, 'staff'> | null {
  if (meta['reviewer'] && !who.isReviewer) return 'reviewer';
  if (meta['judge'] && !who.isJudge) return 'judge';
  if (meta['channelL1'] && !who.isChannelL1) return 'channel_l1';
  return null;
}
